// This import must remain first so the OTel SDK is initialized
// before any other code runs fetch/XHR
import "@/setup/observability";

import { App } from "./App";
import { initializePostHog } from "@/Integrations/initializePostHog";
import { initializeErrorReporting } from "@/Integrations/initializeErrorReporting";
import { syncDeveloperModeFromUrl } from "@/Helpers/developerMode";

import "@/setup/setup";

import { createRoot } from "react-dom/client";

initializePostHog();
initializeErrorReporting();

// Persist any `?dev=1` / `?dev=0` opt-in before the app reads the dev-mode gate.
syncDeveloperModeFromUrl();

async function bootstrap() {
  // Start the MSW worker BEFORE React mounts so the first API calls go
  // through the registered handlers. The whole mock subsystem (MSW
  // library, handlers, fixtures preload) is dev-only — `import.meta.env.DEV`
  // is statically replaced at build time, so the prod build dead-code-
  // eliminates this branch and Vite drops `./App/Mock` (and `msw`
  // transitively) from the bundle entirely.
  if (import.meta.env.DEV) {
    const { startMockWorker } = await import("@/App/Mock/worker");
    await startMockWorker();
  }
  const container = document.getElementById("fs-root");
  const root = createRoot(container!);
  root.render(<App />);
}

void bootstrap();
